import { useEffect, useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { Customer } from "hooks/CustomerManagement/useGetCustomerQuery";
import DashboardLayout from "Layout/DashboardLayout";
import { ManualOrderCustomerSelection } from "Pages/User/OrderManagement/manual/ManualOrderCustomerSelection";
import { useGetCreditReport } from "hooks/Report/useGetCreditReport";
import Button from "Components/Button";
import { useGetOrderReport } from "hooks/Report/useGetOrderReport";
import CreditReports from "./CreditReports";

const Report = () => {
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(
    null
  );
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [payload, setPayload] = useState({});
  const [fetchReport, setFetchReport] = useState(false);

  const handleReset = () => {
    setPayload({});
    setEndDate("");
    setStartDate("");
    setStatus("");
    setPaymentStatus("");
    setSelectedCustomer(null);
  };

  const { RangePicker } = DatePicker;

  const { isLoading: isLoadingOrderReport, isSuccess } = useGetOrderReport(
    startDate,
    endDate,
    selectedCustomer?.id,
    status,
    paymentStatus,
    fetchReport
  );

  const handleGenerateReport = () => {
    setFetchReport(true);
  };

  useEffect(() => {
    if (isSuccess) {
      setFetchReport(false);
    }
  }, [isSuccess]);

  return (
    <DashboardLayout title="Report" back={false}>
      <div className="px-4 mt-4 max-w-[1000px] mx-auto">
        <div className="grid grid-cols-2 gap-x-4">
          <div className="p-[18px] rounded-[10px] bg-[#FFF5F0]">
            <h3 className="text-black text-[18px] font-bold flex gap-2">
              <Icon1 /> Generate Order Report
            </h3>
            <p className="text-grey mt-3">
              Proceed to filter by date or customer to complete the process
            </p>
            <RangePicker
              showTime
              className={
                "mt-4 p-3 mb-3 text-[16px] bg-white w-full border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              }
              value={
                startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null
              }
              onCalendarChange={(dates, dateStrings) => {
                if (dates && dates[0] && dates[1]) {
                  // When dates are selected
                  const startDate = dates[0].format("YYYY-MM-DD");
                  const endDate = dates[1].format("YYYY-MM-DD");

                  setStartDate(startDate);
                  setEndDate(endDate);

                  setPayload({ ...payload, startDate, endDate });
                } else {
                  // When the calendar is cleared
                  setStartDate("");
                  setEndDate("");
                  setPayload({ ...payload, startDate: "", endDate: "" });
                }
              }}
            />
            <div className="flex flex-row gap-3 mb-3 text-[14px]">
              <span className="w-4/12">
                <h3 className="mb-2">Customer</h3>
                <ManualOrderCustomerSelection
                  selectedCustomer={selectedCustomer}
                  setSelectedCustomer={setSelectedCustomer}
                />
              </span>
              <span className="w-4/12">
                <h3 className="mb-2">Status</h3>
                <select
                  className="p-2 rounded-md w-full"
                  value={status}
                  onChange={(e) => setStatus(e?.target?.value)}
                >
                  <option value="">Select Option</option>
                  <option value="placed">Placed</option>
                  <option value="processing">Processing</option>
                  <option value="shipped">Shipped</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="rejected">Rejected</option>
                </select>
              </span>
              <span className="w-4/12">
                <h3 className="mb-2">Payment Status</h3>
                <select
                  className="p-2 rounded-md w-full"
                  value={paymentStatus}
                  onChange={(e) => setPaymentStatus(e?.target?.value)}
                >
                  <option value="">Select Option</option>
                  <option value="paid">Paid</option>
                  <option value="pending">Pending</option>
                </select>
              </span>
            </div>
            {/* <div className="p-3 flex justify-between">
              <h3>Customer</h3>
              <ManualOrderCustomerSelection
                selectedCustomer={selectedCustomer}
                setSelectedCustomer={setSelectedCustomer}
              />
            </div>
            <div className="p-3 flex items-center justify-between mb-3">
              <h3>Status</h3>
              <select
                className="w-[150px] p-2 rounded-md"
                value={status}
                onChange={(e) => setStatus(e?.target?.value)}
              >
                <option value="">Select Option</option>
                <option value="placed">Placed</option>
                <option value="processing">Processing</option>
                <option value="shipped">Shipped</option>
                <option value="cancelled">Cancelled</option>
                <option value="rejected">Rejected</option>
              </select>
            </div>
            <div className="p-3 flex items-center justify-between mb-3">
              <h3>Payment Status</h3>
              <select
                className="w-[150px] p-2 rounded-md"
                value={paymentStatus}
                onChange={(e) => setPaymentStatus(e?.target?.value)}
              >
                <option value="">Select Option</option>
                <option value="paid">Paid</option>
                <option value="pending">Pending</option>
              </select>
            </div> */}
            <Button
              className={`text-white p-[12px] w-full font-bold rounded-md ease-in-out duration-300 ${
                startDate !== "" && endDate !== ""
                  ? "bg-brown cursor-pointer"
                  : "opacity-50 cursor-not-allowed"
              }`}
              disabled={
                startDate === "" || endDate === "" || isLoadingOrderReport
              }
              isLoading={isLoadingOrderReport}
              onClick={handleGenerateReport}
              label={"Generate"}
            />
            <button
              onClick={handleReset}
              className="mt-3 text-[12px] text-orange  p-2 rounded-md "
            >
              Reset
            </button>
          </div>
          <CreditReports />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Report;

const Icon1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
      />
    </svg>
  );
};
